export const subscriptionTypesMap = {
  free: 'free',
  mini: 'mini',
  single: 'single',
  business: 'business',
};

export const twoFactorTypesMap = {
  topt: 1,
  email: 2,
};
